import * as z from 'zod';

import { CustomTemplateId, LosId } from '../BrandedIds';
import { BulkBorrowerAccess } from '../loan/DocumentAccess';

const BulkGenerateCustomTemplatesLoan = z.object({
  id: LosId,
  borrowerAccess: BulkBorrowerAccess.default('all'),
});

export const BulkGenerateCustomTemplatesParams = z.object({
  templateId: CustomTemplateId,
});
export type BulkGenerateCustomTemplatesParams = z.infer<typeof BulkGenerateCustomTemplatesParams>;

// No per-request loan cap: callers can split into many requests and the queue
// consumer processes rows serially either way, so a cap doesn't bound load.
export const BulkGenerateCustomTemplatesRequest = z.object({
  // Reject duplicate loan ids: the per-row guard keys on array position, so a repeated
  // id would render the document — and email the borrowers — once per occurrence.
  loans: z
    .array(BulkGenerateCustomTemplatesLoan)
    .min(1)
    .refine((loans) => new Set(loans.map((loan) => loan.id)).size === loans.length, {
      message: 'Duplicate loan ids are not allowed',
    }),
});
export type BulkGenerateCustomTemplatesRequest = z.infer<typeof BulkGenerateCustomTemplatesRequest>;
